// This file is auto-generated by @hey-api/openapi-ts

/**
 * Ticket state
 */
export const TicketStateEnum = {
    CANCELLED: 'CANCELLED',
    EXPIRED: 'EXPIRED',
    ACTIVE: 'ACTIVE',
    FUTURE: 'FUTURE',
    TO_PRINT: 'TO_PRINT'
} as const;

/**
 * Ticket state
 */
export type TicketStateEnum = typeof TicketStateEnum[keyof typeof TicketStateEnum];
